import { render } from "./SignupTokenInvalid.vue?vue&type=template&id=6cd8ec71&scoped=true"
import script from "./SignupTokenInvalid.vue?vue&type=script&lang=js"
export * from "./SignupTokenInvalid.vue?vue&type=script&lang=js"

import "./SignupTokenInvalid.vue?vue&type=style&index=0&id=6cd8ec71&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd8ec71"]])

export default __exports__